import React from "react";
import './textbox.css';

const Textbox = () => {
    return(
    <div className='Headtext'>

        <h1 className="bold-text">
          A brand and product designer working with clients globally
        </h1>
        <div className="category-container">
        <div className='categories'>
          Expertise
        </div>
        <div className='categories'>
          Branding
        </div>
        <div className='categories'>
          Product
        </div>
        </div>
      </div>
    )
}

export default Textbox;